export const loanPaymentSuccessAction = (state = false, action) => {
  switch (action.type) {
    case "LOAN_PAYMENT_SUCCESS_CHECKER":
      return action.data;

    default:
      return state;
  }
};
